let Footer = () => {
    return(
        <div id="footerBox" className = "mt-auto">
            <footer>
                <div id="footerContainer">
                    <div>
                        <h4>Linki</h4>
                        <a href="https://erasmus-plus.ec.europa.eu/pl" target="_blank">Erasmus+</a><br />
                        <a href="https://euromind.es/portfolio-category/all-projects/" target="_blank">EuroMind </a>
                    </div>
                    
                    <div>
                        <h4>Kontakt</h4>
                        <a href="https://www.zsi.kielce.pl/" target="_blank">Zespół Szkół Informatycznych <br />im. gen. Józefa Hauke Bosaka</a><br />
                        <a href="https://g.page/Informatyk_Kielce?share" target="_blank">ul. Warszawska 96 25 - 401 Kielce</a><br />
                        <a href="tel:+48123456789">tel: 41 367 67 90</a><br />
                        <a href="/#">fax: 41 367 69 33</a><br />
                        <a href="mailto:szkola@zsi.kielce.pl">szkola@zsi.kielce.pl</a>
                    </div>
                </div>
                
                <hr />
                <section>© Copyright 2023. Zespół Szkół Informatycznych w Kielcach - Technikum nr 7</section>
            </footer>
        </div>
    )
}

export default Footer;